'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (h) {
  return h('div', {
    attrs: {
      id: this.id
    }
  });
};